import axios from 'axios'
import { getAdminAuthHeader } from '../utils/auth'

function authCfg(extra = {}) {
  return {
    ...extra,
    headers: { ...(extra.headers || {}), ...getAdminAuthHeader() }
  }
}

export async function fetchInventoryRegions() {
  const resp = await axios.get('/api/inventory/regions', authCfg())
  return resp.data
}

export async function fetchInventoryUnits() {
  const resp = await axios.get('/api/inventory/units', authCfg())
  return resp.data
}

export async function fetchInventoryCategories() {
  const resp = await axios.get('/api/inventory/categories', authCfg())
  return resp.data
}

export async function fetchInventoryProducts() {
  const resp = await axios.get('/api/inventory/products', authCfg())
  return resp.data
}

export async function fetchCurrentStock(itemId) {
  const resp = await axios.get('/api/inventory/current-stock', authCfg({ params: { itemId } }))
  return resp.data
}

export async function fetchInventoryRows({ region = 'all', category = 'all', keyword = '' } = {}) {
  const resp = await axios.get('/api/inventory/rows', authCfg({ params: { region, category, keyword } }))
  return resp.data
}

export async function fetchInventoryStats({ rangeType = 'today', startDate = '', endDate = '' } = {}) {
  const resp = await axios.get(
    '/api/inventory/stats',
    authCfg({ params: { rangeType, startDate, endDate } })
  )
  return resp.data
}

export async function fetchInventoryVisualization(days = 30) {
  const resp = await axios.get('/api/inventory/visualization', authCfg({ params: { days } }))
  return resp.data
}

export async function fetchInventoryLogs({
  type,
  region = 'all',
  category = 'all',
  keyword = '',
  operator = '',
  startDate = '',
  endDate = '',
  page = 1,
  pageSize = 10
} = {}) {
  const resp = await axios.get(
    '/api/inventory/logs',
    authCfg({
      params: { type, region, category, keyword, operator, startDate, endDate, page, pageSize }
    })
  )
  return resp.data
}

export async function submitInbound({ itemId, productId, quantity, operator, remark }) {
  const resp = await axios.post(
    '/api/inventory/inbound',
    {
      itemId: itemId || productId,
      quantity,
      operator,
      remark
    },
    authCfg()
  )
  return resp.data
}

export async function submitOutbound({ itemId, productId, quantity, operator, remark }) {
  const resp = await axios.post(
    '/api/inventory/outbound',
    {
      itemId: itemId || productId,
      quantity,
      operator,
      remark
    },
    authCfg()
  )
  return resp.data
}

export async function createInventoryItem(payload) {
  const resp = await axios.post('/api/inventory/items', payload, authCfg())
  return resp.data
}

export async function adjustInventoryItem(id, payload) {
  const resp = await axios.put(`/api/inventory/items/${id}/adjust`, payload, authCfg())
  return resp.data
}

function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export async function downloadInventoryTemplate() {
  const resp = await axios.get('/api/inventory/template', authCfg({ responseType: 'blob' }))
  const cd = resp.headers && resp.headers['content-disposition']
  let name = 'EATing库存导入模板.xlsx'
  if (cd && /filename\*=UTF-8''([^;]+)/i.test(cd)) {
    try {
      name = decodeURIComponent(RegExp.$1)
    } catch (e) {}
  } else if (cd && /filename="?([^";]+)"?/i.test(cd)) {
    name = RegExp.$1
  }
  triggerBlobDownload(resp.data, name)
}

export async function exportInventoryExcel(params = {}) {
  const resp = await axios.get('/api/inventory/export', authCfg({ params, responseType: 'blob' }))
  const cd = resp.headers && resp.headers['content-disposition']
  let name = 'EATing门店库存导出.xlsx'
  if (cd && /filename\*=UTF-8''([^;]+)/i.test(cd)) {
    try {
      name = decodeURIComponent(RegExp.$1)
    } catch (e) {}
  } else if (cd && /filename="?([^";]+)"?/i.test(cd)) {
    name = RegExp.$1
  }
  triggerBlobDownload(resp.data, name)
}

export async function importInventoryExcel(file, operator) {
  const fd = new FormData()
  fd.append('file', file)
  if (operator) fd.append('operator', operator)
  const resp = await axios.post(
    '/api/inventory/import',
    fd,
    authCfg({ headers: { 'Content-Type': 'multipart/form-data' } })
  )
  return resp.data
}
